import { DateTime } from 'luxon';
import { defineStore } from 'pinia';
let globalId = 0;

export type AlertType = 'info' | 'success' | 'warning' | 'danger';

export interface Alert {
  title: string;
  description?: string | null;
  toast?: boolean;
  unread?: boolean;
  persistent?: boolean;
  type?: AlertType;
  date?: DateTime | null;
  time?: string | null;
  delay?: number | null;
  actions?: {
    name: string;
    handler: () => void;
  }[];
}

export type RegisteredAlert = Required<Alert> & { id: number; };

export const useAlertStore = defineStore('drawer', {
  state() {
    return { alerts: [] as RegisteredAlert[] };
  },

  getters: {
    countUnread(): number {
      return this.alerts.reduce((sum, m) => sum + (m.unread ? 1 : 0), 0);
    },
  },

  actions: {
    add({
      title,
      description = null,
      toast = false,
      unread = true,
      persistent = false,
      type = 'info',
      actions = [],
      date = null,
      time = null,
      delay = null,
    }: Alert = {
        title: '',
      },
    ) {
      const messageObj: RegisteredAlert = {
        id: ++globalId,
        title,
        description,
        toast,
        unread,
        persistent,
        type,
        actions,
        date,
        time,
        delay: delay ?? ((type === 'info' || type === 'success') ? 4000 : 8000),
      };

      if (!messageObj.date && !messageObj.time) {
        messageObj.time = DateTime.local().toLocaleString(DateTime.TIME_24_WITH_SECONDS);
      }

      this.alerts.push(messageObj);
    },

    update({ id, ...data }: Partial<Alert> & { id: number; }) {
      const index = this.alerts.findIndex(m => m.id == id);
      if (typeof index !== 'undefined' && this.alerts[index]) {
        Object.assign(this.alerts[index], data);
      }
    },

    delete(id: number) {
      this.alerts = this.alerts.filter(m => m.id !== id);
    },

    clear() {
      this.$reset();
    },
  },
});
